module.exports = __webpack_public_path__ + "static/media/calalloyGradient.706d15c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/calalloyGradient.jpg
// module id = 1000
// module chunks = 0